import React from 'react';
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined } from '@ant-design/icons';
import "./ImportLog.scss";

const ImportLog = ({ logs, isProcessing, currentIndex }) => {
  return (
    <div className="import-log">
      {logs.map((log) => (
        <div key={log.id} className={`import-log-item import-log-item--${log.status}`}>
          <span className="import-log-item__text">{log.message}</span>
          <span className="import-log-item__icon">
            {log.status === 'success' ? <CheckCircleFilled /> : <CloseCircleFilled />}
          </span>
        </div>
      ))}
      {isProcessing && (
        <div className="import-log-item import-log-item--processing">
          <span className="import-log-item__text">
            STT {(currentIndex || 0) + 1}: Đang xử lý...
          </span>
          <span className="import-log-item__icon">
            <LoadingOutlined />
          </span>
        </div>
      )}
    </div>
  );
};

export default ImportLog;
